<mat-icon [ngStyle]="enableRemove ? {'visibility': 'visible'} : {'visibility': 'hidden'}"
          [matTooltip]="enableRemove ? ('forms.common.controls.remove_row.tooltip' | translate) : null"
          matTooltipPosition="right"
          class="row-action-icon"
          (click)="updateArrayClicked(false)">
  remove
</mat-icon>
<mat-icon [ngStyle]="enableAdd ? {'visibility': 'visible'} : {'visibility': 'hidden'}"
          [matTooltip]="enableAdd ? ('forms.common.controls.add_row.tooltip' | translate) : null"
          matTooltipPosition="right"
          class="row-action-icon text-right"
          (click)="updateArrayClicked(true)">
  add
</mat-icon>
